var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "canned-message-selector",
      class: {
        "search-mode": _vm.isSearchStarted(),
      },
    },
    [
      _vm.isEmpty()
        ? _c("div", { staticClass: "empty" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("message.noCannedMessages"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "message" }, [
              _vm._v(_vm._s(_vm.$t("message.filterToFindMore"))),
            ]),
          ])
        : [
            !_vm.isSearchStarted()
              ? _c(
                  "div",
                  { staticClass: "groups" },
                  _vm._l(_vm.getItems(), function (group, index) {
                    return _c(
                      "div",
                      {
                        key: group._id,
                        staticClass: "group",
                        class: {
                          selected: _vm.selectedGroupId === group._id,
                          hoverSelected:
                            _vm.pointerside === "groups" &&
                            _vm.getSelectedGroupIndex() === index,
                        },
                        attrs: { "data-id": group._id, "data-pointer": index },
                        on: {
                          click: function ($event) {
                            return _vm.selectGroup(group._id)
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.getContentFromLanguage(group, "name")
                              ) +
                              "\n                "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v(" chevron_right "),
                        ]),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "items" },
              _vm._l(_vm.getSelectedGroup().children, function (item, index) {
                return _c(
                  "div",
                  {
                    key: item._id,
                    staticClass: "item-card",
                    class: {
                      selected: _vm.pointerIndex === index,
                      hoverSelected:
                        _vm.pointerside === "items" &&
                        _vm.pointerIndex === index,
                    },
                    attrs: { "data-id": item._id, "data-pointer": index },
                    on: {
                      click: function ($event) {
                        return _vm.triggerReadyContent(item, "content")
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "title-wrapper" }, [
                      _c("div", { staticClass: "title" }, [
                        _vm.isSearchStarted
                          ? _c("span", [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.getContentFromLanguage(
                                      item.parent,
                                      "name"
                                    )
                                  ) +
                                  "\n                            "
                              ),
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v(" chevron_right "),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.getContentFromLanguage(item, "name")) +
                            "\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "shortcut" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.getPressKey(item)) +
                            "\n                    "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "message-preview" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.getContentFromLanguage(item, "content")) +
                          "\n                "
                      ),
                    ]),
                  ]
                )
              }),
              0
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }